// extracted by mini-css-extract-plugin
module.exports = {"IFrame":"_1-yNJDcToEM7H3T_1rSDyq","CloseIcon":"_3V59I2w0rU_rZZktaCJx0e"};